<template>
  <v-container fill-height fluid>
    <v-row justify="center">
      <v-col cols="12">
        <base-material-card :title="title">
          <v-form @submit.prevent="handleSubmit">
            <v-container class="py-0">
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    autocomplete="off"
                    :disabled="isReadOnly"
                    v-model="resource.name"
                    name="name"
                    label="Name"
                  />
                </v-col>

                <v-col v-if="selectSite" cols="6">
                  <v-autocomplete
                    autocomplete="off"
                    :disabled="isReadOnly"
                    :items="sites"
                    name="site"
                    label="Site"
                    v-model="resource.site"
                    item-text="name"
                    item-value="id"
                    hide-details
                  />
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    :disabled="isReadOnly"
                    v-model="resource.mac"
                    name="mac"
                    label="Mac"
                  />
                </v-col>
              </v-row>
              <v-row>
                <FormActions
                  :cancel="handleCancel"
                  :submit="handleSubmit"
                  :destroy="handleDestroy"
                  :canDestroy="canDestroy"
                  :canEdit="canEdit"
                  :canCreate="canCreate"
                  :isValid="isValid"
                  :submitting="submitting"
                />
              </v-row>
            </v-container>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Formable from '@/mixins/formable';

export default {
  mixins: [Formable],
  props: {
    sites: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    selectSite() {
      return this.sites.length > 1;
    },
  },
  data() {
    return {
      resourceName: 'AllocationUnit',
    };
  },
};
</script>
